<template>
  <div class="page">
    <h2 class="title">有看投隐私政策</h2>
    <h2>更新日期：2025年10月17日</h2>
    <h2>生效日期：2025年10月17日</h2>
    <p>
      上海第一财经传媒有限公司（注册地址：上海市静安区南京西路651号广电大厦，联系电话：021-22005899，以下或称“我们”“公司”“有看投”），深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。您在使用我们的产品或服务时，我们将按照《有看投隐私政策》（以下简称“本政策”）收集、存储、使用及对外提供您的个人信息。
    </p>
    <p>
      为了保证对您的个人信息合法、合理、适度的采集使用，并在安全、可控的情况下进行传输、存储，我们制定了本政策，请您仔细阅读本政策并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可按照本政策列明的方式联系我们的客服咨询。<strong
    >如您选择同意本政策，或者使用或继续使用我们的产品或服务，即意味着您同意本政策的条款，并同意我们按照本政策收集、使用、储存和对外提供您的相关信息；如您不同意本政策中的任何条款，您应立即停止访问和使用我们的产品或服务。</strong
    >
    </p>
    <h2>本政策将帮助您了解以下内容：</h2>
    <p>一、 我们如何收集您的个人信息</p>
    <p>二、 我们如何使用Cookie等技术</p>
    <p>三、 我们如何存储和保护您的个人信息</p>
    <p>四、 我们如何使用您的个人信息</p>
    <p>五、 我们如何对外提供您的个人信息</p>
    <p>六、 您如何访问和管理您的个人信息</p>
    <p>七、 儿童隐私权特别约定</p>
    <p>八、 本政策的适用及更新</p>
    <p>九、 管辖与法律适用</p>
    <p>十、 如何联系我们</p>
    <p>
      <strong
      >本政策与您使用我们的产品或服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。对本政策中与您的权益存在重大关系的条款，我们采用粗体字进行标注以提示您注意。</strong
      >
    </p>
    <h2>一、 我们如何收集您的个人信息</h2>
    <p>
      您使用我们的产品或服务时，在以下情形中我们需要收集您的个人信息，用以向您提供服务、提升我们的服务质量以及遵守国家法律法规及监管规定。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务。
    </p>
    <h2>（一） 注册、登录</h2>
    <p>
      1、
      当您登录我们的软件、注册账户或在购买我们的产品或者服务时，需要填写或提交<strong>手机号码</strong>。为了完成登录，我们会向您提供的手机号码发送短信验证码，以验证您的身份是否有效，验证过程中可能会使用<strong>短信权限</strong>。手机号码属于您的个人信息，收集此类信息是为了满足相关法律法规的网络实名制要求，若您不提供手机号码，您可能无法正常使用我们的服务。
    </p>
    <p>
      2、基于我们与通信运营商的合作，当您使用“一键登录”功能时，通过您以链接、点击等方式明示同意后，运营商会将您的手机号码发送给我们（在此过程中经您同意后可能会使用电话权限），便于我们为您提供快捷的登录服务。手机号码属于您的个人信息，如果拒绝提供将无法使用“一键登录”方式登录有看投，但不影响您通过其他方式登录。
    </p>
    <h2>（二） 监管与风险防范</h2>
    <p>
      为了保障互联网应用的业务安全风控，应对欺诈、违法等安全风险，满足监管要求，提升服务安全性，防止您的个人信息被违法获取，您同意我们记录您使用产品的方式及相关操作信息，例如硬件序列号、操作系统版本、设备MAC地址、IP地址、无线网络接入信息、唯一设备识别码（包括IMEI/OAID/Android
      ID/IDFA/Open
      UDID/GUID/SIM卡IMSI信息）、软件版本号、网络接入方式、类型、状态、操作、使用产品使用习惯以及其他与我们产品或服务相关的日志信息以及其他能识别客户终端的特征代码，这些信息是我们为提供产品或服务基本功能而必须收集的信息。除了产品基本功能外，我们还提供一些附加功能来提升用户体验，需要收集以下权限与信息：设备权限、位置信息、设备功能。
    </p>
    <h2>1、疑问解答、投诉处理及合规回访</h2>
    <p>
      我们收集您的手机号码用于电话解答您在使用产品或服务过程中的疑问，并对您的投诉进行处理，同时对您使用产品或服务进行合规回访。如果您拒绝提供手机号码，则可能影响我们通过电话解答您的疑问与投诉；如您拒绝接听工作人员的回电，未能完成合规回访流程，可能会影响您继续使用有看投的产品或服务。
    </p>
    <h2>2、风险提示</h2>
    <p>
      我们收集您的合规录音作为您使用我们产品或服务的合规程序，并对您进行风险提示。如您拒绝向我们提供合规录音，可能影响您接收风险提示，并影响您继续使用有看投的产品或服务。
    </p>
    <h2>3、图片上传建议、材料</h2>
    <p>
      当您使用图片上传您使用我们产品或服务的建议以及相关材料，，我们会收集您的图片信息。如果您拒绝提供图片，将无法使用图片上传和导入功能，但不影响您使用我们的其他服务。
    </p>
    <h2>4、 设备权限</h2>
    <p>
      在提供服务过程中，可能需要您开通一些设备权限，我们会通过弹窗等方式向您确认<strong>通知、WIFI及移动网络数据、拨打电话、摄像头、音频、麦克风、录音、相册或手机存储的权限</strong>，具体如下：
    </p>
    <p>（1） 通知</p>
    <p>
      允<strong>许通知，可以为您提供重点事项的通知</strong>（如评论、预警、活动、行业重要公告、系统升级等）、服务资讯的推送等。
    </p>
    <p>
      如您拒绝提供或希望关闭通知，您可以通过您的终端设备的设置菜单进行关闭选择，关闭通知会影响向您提供重点事项的通知、服务资讯的推送等功能，但不影响您使用我们的其他服务。
    </p>
    <p>（2） WIFI及移动网络数据的权限</p>
    <p><strong>允许使用WLAN与移动网络。</strong>用于您使用我们的产品及服务。</p>
    <p>
      如您拒绝或希望关闭WIFI及移动网络数据的权限，您可以在您的终端设备的设置菜单进行关闭选择，同时关闭两项权限将会影响您使用我们的服务。
    </p>
    <p>（3）电话、音频及麦克风权限</p>
    <p><strong>允许语音搜索与语音输入，提升客户服务效率。</strong></p>
    <p>
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您使用语音搜索功能，也可能影响我们通过语音方式解答您的疑问与投诉。
    </p>
    <p>（4） 录音权限</p>
    <p>
      <strong>允许录音或通话录音权限。</strong
      >由于您在使用产品/服务过程中，需要进行风险提示、合规录音。
    </p>
    <p>
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您接收风险提示，合规录音，可能会影响您使用有看投的产品或服务。
    </p>
    <p>（5） 摄像头、相机权限</p>
    <p><strong>允许获取您的摄像头、相机权限。</strong></p>
    <p>
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您拍照提供产品建议、上传材料、图片导入自选股以及视频功能，但并不影响您使用我们的其他服务。
    </p>
    <p>（6） 相册权限及手机存储权限</p>
    <p><strong>允许获取您的相册权限及手机存储权限。</strong></p>
    <p>
      如您拒绝或希望关闭该功能，您可以通过在您的终端设备的设置菜单进行关闭选择，这将会影响您缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能，但并不影响您使用我们的其他服务。
    </p>
    <p>（7）剪贴板</p>
    <p><strong>允许使用剪贴板。</strong></p>
    <p>
      如果您拒绝或希望关闭该功能，您可以通过您的终端设备的设置菜单进行关闭选择，这将会影响您复制、粘贴文本信息，但不影响您使用我们的其他服务。
    </p>
    <p>
      当您使用上述附加功能时，我们会取得相关权限的同意。您可以在设备的设置功能中随时选择关闭部分或全部权限，从而拒绝我们收集或提供相应的个人信息。在不同的设备中，权限设置的位置和开启、关闭方式可能不同，请以您使用设备的说明为准。
    </p>
    <h2>5、设备功能</h2>
    <p>
      为了方便您使用APP中的分时K线查看、自选股查看、市场排名查看、视频的横竖屏切换等功能，我们将访问您提供的设备的加速度传感器，以识别您的设备横竖屏状态，适配您的机型展示。请您知晓并理解，上述加速传感器不涉及任何个人信息且无法与其他信息结合用于识别特定自然人身份。
    </p>
    <h2>（三） 第三方服务</h2>
    <p>
      1、为了保障客户端稳定运行、功能有效实现，有看投的部分服务需要由有看投与第三方（有看投客户端嵌入的第三方SDK）共同为您提供，来实现前述目的。具体您可以点击<a
        class="c5"
        @click="toSdklist"
    >《第三方信息共享清单》</a
    >查看我们接入的第三方SDK详情。
    </p>
    <p>
      2、有看投不提供证券开户、交易功能服务，证券开户功能、交易功能由第三方证券公司向您提供服务；您可以通过点击方式直接跳转至该证券公司的APP、WEB，相关服务均由第三方证券公司提供。
    </p>
    <p>3、 第三方服务的免责</p>
    <p>
      <strong
      >我们的服务可能包括或链接至第三方提供的信息或其他服务（包括第三方的网站），第三方服务可能会调用您的设备权限、获取您的相关信息。有看投会尽可能对第三方服务进行严格的审核，要求其采取严格的数据保护措施，切实保障您的合法权益。</strong
      >
    </p>
    <p>
      <strong
      >关于第三方服务涉及的权限以及如何收集、使用您的个人信息，建议您仔细阅读第三方服务的相关服务协议及隐私政策条款，谨慎提供个人信息。如您发现第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。</strong
      >
    </p>
    <p>
      <strong
      >本隐私政策仅适用于我们提供的产品或服务，不适用于任何第三方提供的服务或第三方的个人信息安全政策，有看投对任何第三方收集、使用、处理由您提供或授权的信息（包括您的个人信息）不承担任何责任。</strong
      >
    </p>
    <p>（四） 提升服务质量</p>
    <p>
      为提高您对有看投产品或服务使用感受和满意度，我们可能会收集您的操作行为信息、搜索记录、您与客户服务团队联系时提供的信息及您参与问卷调查时向我们发送的信息，以便进行调查研究和分析，从而进一步优化服务。
    </p>
    <p>（五）营销推广服务</p>
    <p>
      当您选择参加我们及我们的关联方或第三方举办的有关营销活动时，需要您提供<strong>姓名、通信地址、联系方式、银行账号信息（包括：开户行、卡号、开户行地址、所属类型）</strong>。这些信息是个人信息、拒绝提供会影响您参加相关活动，但不会影响其他功能。只有经过您的同意，我们才会将这些信息与关联方或第三方共享，以保障您在联合活动中获得体验一致的服务，或委托第三方及时向您兑现奖励。
    </p>
    <div class="strong">
      <p>
        （六）根据法律法规规定及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
      </p>
      <p>1、 与国家安全、国防安全直接相关的；</p>
      <p>2、 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>3、 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>
        4、
        出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      </p>
      <p>
        5、 所收集的信息是您自行向社会公开的或者是从合法公开的渠道中收集到的；
      </p>
      <p>6、 根据您的要求签订和履行合同所必需的；</p>
      <p>
        7、
        用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
      </p>
      <p>8、 法律法规规定的其他情形。</p>
      <p>
        请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程等方式向您说明收集的内容、范围和目的，以征得您的同意。
      </p>
    </div>
    <p>
      如您希望更详细的了解我们收集个人信息的类型与目的，您可以详细阅读<a class="c5"
                                                                        @click="toPersonal">《个人信息收集清单》</a>。
    </p>
    <h2>二、 我们如何使用Cookie等技术</h2>
    <h3>（一） Cookie</h3>
    <p>
      通过使用
      Cookie，我们可以为用户提供更为方便和快捷的登录服务和用户体验。Cookie
      是由网页服务器存放在用户的硬盘中的文本文件。Cookie不能用来运行程序或将病毒递送到用户的计算机中。指定给用户的Cookie是唯一的，它只能由将
      Cookie 发布给用户的域中的Web服务器读取。绝大多数浏览器会默认使用
      Cookie，如果用户的浏览器设置为拒绝
      Cookie，在使用时将无法完全体验到该服务相关的服务体验。
    </p>
    <p>
      用户离开、关闭我们的相关软件和服务后，与此用户相关的Cookie数据也会在对应用户电脑上自动删除。
    </p>
    <h3>（二） Do Not Track（请勿追踪）</h3>
    <p>
      很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not
      Track请求。目前主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do
      Not Track，那么我们的所有网站都会尊重您的选择。
    </p>
    <h3>（三） 日志信息</h3>
    <p>
      在您访问我们的网站或使用我们的服务时，我们可能会收集日志信息，主要用于记录您浏览我们产品或服务时的行为，在进行特殊处理且无法定位到特定用户后，用于数据分析来改善产品服务及用户体验，及时发现并防范安全风险。
    </p>
    <h2>三、 我们如何存储和保护您的个人信息</h2>
    <h3>（一） 存储</h3>
    <p>
      我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如部分产品涉及跨境业务，为履行与您的合同之必需，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门的规定执行，并通过签订协议、现场核查等有效措施，要求境外机构为所获得的您的个人信息保密及采取安全措施。
    </p>
    <p>
      我们会采取合理可行的措施，尽力避免收集无关的个人信息。<strong>我们只会在达成本政策所述目的所需的最短期限内保留您的个人信息，除非法律法规等有强制的留存要求</strong>，如《证券期货投资者适当性管理办法》要求经营机构应当按照相关规定妥善保存其履行适当性义务的相关信息资料，对匹配方案、告知警示资料、录音录像资料、自查报告等的保存期限不得少于20年。而我们判断前述期限的标准包括：
    </p>
    <p>
      1.完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；
    </p>
    <p>2.保证我们为您提供服务的安全与质量；</p>
    <p>3.您是否同意更长的留存期间；</p>
    <p>4.是否存在保留期限的其他特别约定。</p>
    <h3>（二） 保护</h3>
    <p>
      为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。例如：按照传输加密，存储加密，访问加密的技术规范推行各个系统的用户信息的使用和存储。同时我们设立了相关内控制度，对可能接触到您的信息的工作人员采取最小必要授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。另外，目前我们的重要信息系统已经通过网络安全等级保护的二级及以上测评。
    </p>
    <p>
      在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议等。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    </p>
    <p>
      我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。如您发现您的用户名、密码及其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。
    </p>
    <p class="strong">
      您知悉并理解，尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。
    </p>
    <p class="strong">
      在您终止使用我们的产品及服务后，我们将根据适用法律的要求停止收集您个人信息的活动。在您的个人信息超出保留期间后，我们将根据适用法律的要求对您的个人信息进行删除或匿名化处理。
    </p>
    <h2>四、 我们如何使用您的个人信息</h2>
    <p>
      （一）
      为了遵守国家法律法规及监管要求，以及向您提供产品、服务及提升产品、服务质量，或保障您的账户安全，我们会在以下情形中使用您的信息：
    </p>
    <p>
      1、
      我们会根据本政策的约定并为实现我们的产品、服务功能对所收集的个人信息进行使用。
    </p>
    <p>2、 根据法律法规或监管要求向相关部门进行报告。</p>
    <p>3、 邀请您参与我们产品或服务有关的客户调研。</p>
    <p>
      4、
      我们会对您的信息进行综合统计、分析加工，以便为您提供更加优质的服务，或帮助我们评估、改善或设计产品、服务及运营活动等。
    </p>
    <p>
      5、
      在收集您的个人信息后，我们在通过技术手段对您的信息数据进行充分去标识化处理后，有权在不经您同意的情况下直接使用，有权对用户数据库进行分析并予以商业化的利用。该等去标识化的信息将无法识别或关联信息主体。
    </p>
    <p>
      6、当我们展示您的个人信息时，我们会采用包括去标识化或匿名化处理方式对您的信息进行处理，以保护您的信息安全。
    </p>
    <p>
      7、
      您充分理解并同意：为了保证您对产品的正常使用并提升您的服务体验，<strong
    >有看投可以根据您的用户信息，通过短信、电话、邮件等各种方式与您联系并向您提供关于有看投产品或服务信息、风险提示信息、产品营销及活动推广通知等各类信息。</strong
    >
    </p>
    <p>
      如您不希望接收关于我们产品、服务信息、产品营销及活动推广通知等各类信息的，您可通过回复短信退订以拒绝该类短信，或关闭通知推送按钮。如您拒绝接收风险提示信息、合规回访电话的，将有可能无法正常使用我们的产品和服务。
    </p>
    <p>
      （二）
      您在使用我们的产品和服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品服务期间持续授权我们使用。当您注销账户后,我们将停止收集您的个人信息，并在满足法律法规及监管规定的基础上，及时删除您的个人信息或进行匿名化处理。
    </p>
    <p class="strong">
      （三）
      当我们要将个人信息用于本政策未载明的其他用途前，会按照法律法规及国家标准的要求以协议、具体场景下的文案确认动作等形式再次征求您的同意。
    </p>
    <p>五、 我们如何对外提供您的个人信息</p>
    <p class="strong">（一）委托处理</p>
    <p class="strong">
      您理解并知悉，为了向您提供更完善、优质的产品和服务，我们将授权商业合作伙伴为您提供部分服务，此种情形下，我们可能会与合作伙伴提供您的某些个人信息，以为您提供更好的服务和体验。请您注意，我们仅会出于合法、正当、必要、特定、明确的目的提供您的个人信息，并且只会提供履行与您的合同所必要的个人信息。我们将会对信息数据的输出形式、流转、使用进行安全评估与处理，以保护数据安全。
    </p>
    <p class="strong">（二） 共享</p>
    <p>
      我们承诺对您的信息进行保密。除法律法规及监管部门另有规定外，<strong>我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司、合作金融机构以及其他合作伙伴。在将信息提供给第三方前，我们将尽商业上合理的努力评估该第三方收集信息的合法性、正当性、必要性。</strong>我们会要求第三方处理您的个人信息时遵守法律法规，要求第三方对您的信息采取保护措施。
    </p>
    <p>1、事先已获得您的明确同意或授权的；</p>
    <p>2、您自行提出的；</p>
    <p>3、与商业伙伴的必要共享：</p>
    <p class="strong">
      您理解并知悉，为了向您提供更完善、优质的产品和服务，为履行与您的合同之必需，我们的商业合作伙伴为您提供部分服务，此种情形下，我们可能会与合作伙伴共享您的某些个人信息，以为您提供更好的服务和体验。请您注意，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将会对信息数据的输出形式、流转、使用进行安全评估与监督，以保护数据安全。
    </p>
    <p>
      4、根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
    </p>
    <p>
      5、当您投诉我们的业务时，为了保护您的合法权益，我们可能会将您的<strong>姓名</strong>及<strong>有效证件号码、联系方式、投诉相关内容</strong>提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。
    </p>
    <p>
      6、如您希望详细了解我们与第三方共享的个人信息类型和目的，以及有看投平台嵌入的第三方SDK情况，请点击<a
        class="c5"
        @click="toSdklist"
    >《第三方信息共享清单》</a
    >。
    </p>
    <p class="strong">（三） 转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1、 事先获得您的明确同意；</p>
    <p>2、 根据法律法规或强制性的行政或司法要求；</p>
    <p>
      3、
      在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的、方式等超出您此前对于个人信息处理的授权范围时，我们将要求该公司、组织重新取得您的明确同意。
    </p>
    <p class="strong">（四） 披露</p>
    <p>
      我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：
    </p>
    <p>
      1、
      在您明确同意的披露方式下披露您所指定的个人信息，我们会向您告知披露的目的、披露信息的类型及可能涉及的敏感信息；
    </p>
    <p>
      2、
      根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息。
    </p>
    <p class="strong">
      （五）
      根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、披露您的个人信息无需征得您的同意：
    </p>
    <p>1、 与国家安全、国防安全直接相关的；</p>
    <p>2、 与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>3、 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>
      4、
      出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
    </p>
    <p>
      5、 所收集的信息是您自行向社会公开的或者是从合法公开的渠道中收集到的；
    </p>
    <p>6、 法律法规规定的其他情形。</p>
    <h2>六、 您如何访问和管理您的个人信息</h2>
    <p>
      按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
    </p>
    <p class="strong">（一） 访问、更正及更新您的个人信息</p>
    <p>
      您可以在使用我们服务的过程中，通过我们的PC端软件访问、更正及更新您提供的注册信息和其他个人信息，具体路径如下：有看投-右上角点击账号-用户中心-个人信息。对于PC端软件无法更正或更新的个人信息，您也可联系您的客服专员或拨打我们的客服热线咨询更正及更新事宜。您访问、更正及更新个人信息的范围和方式将取决于您使用的具体服务。
    </p>
    <p class="strong">（二） 删除您的个人信息</p>
    <p>
      在以下情形中，您可以向我们提出删除个人信息的请求，我们将在15日内或法律法规规定期限内向您做出答复：
    </p>
    <p>1、 如果我们处理个人信息的行为违反法律法规；</p>
    <p>2、 如果我们未经您的同意收集、使用您的个人信息；</p>
    <p>3、 如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>4、 如果您不再使用我们的产品或服务，或您主动注销了账号。</p>
    <p class="strong">
      当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全的存储您的个人信息并将其与任何进一步处理进行隔离，直至备份可以清除或实现匿名。
    </p>
    <p class="strong">（三） 撤回同意</p>
    <p>
      您可以通过我们提供的手机软件撤回授权，具体路径为：有看投手机软件-首页左上角个人中心-隐私管理-隐私政策-底部撤回同意。点击即可撤回同意。
    </p>
    <p>
      请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。<strong
    >但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong
    >
    </p>
    <p class="strong">（四） 注销账户</p>
    <p>
      我们为您提供了注销账户的服务，我们的手机软件中的注销路径为：拨打客服电话进行注销。<strong
    >当您符合约定的账户注销条件并申请注销账户后，我们将于15日内完成您的账户注销请求，您该账户内的所有信息将被清空，我们将不会再收集、使用或对外提供与该账户相关的个人信息，但您在使用我们的产品或服务期间提供或产生的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询。</strong
    >
    </p>
    <p class="strong">
      在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障账号的安全。请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在15日内答复您的请求。
    </p>
    <h2>七、 儿童隐私权特别约定</h2>
    <p>
      （一）我们将未满十四周岁的未成年人视为儿童。我们的产品和服务并非特别为儿童设计或以儿童为对象，我们不会刻意收集、使用或传播任何儿童的个人信息。我们非常重视儿童个人信息的保护，我们期望父母或其他监护人（以下统称“<strong>监护人</strong>”）指导儿童使用我们的服务。我们将根据所有适用的法律法规的规定保护儿童个人信息的保密性及安全性。
    </p>
    <p>
      （二）我们仅会在征得儿童的监护人同意的情形下处理儿童的个人信息。如果您是儿童的监护人，请您务必仔细阅读和选择是否同意本政策；<strong
    >如您为未成年人，您需要告知您的监护人仔细阅读本政策，并在征得您监护人同意的前提下使用我们的服务或向我们提供您的信息。</strong
    >
    </p>
    <p>
      （三）<strong>儿童个人信息属于敏感个人信息</strong>，对于经监护人同意而使用儿童信息的情况，我们将严格遵守法律法规规定的以及本政策约定的关于敏感个人信息的处理要求，我们还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。
    </p>
    <p>
      （四）如果有事实证明儿童在未取得监护人同意或监护人不同意的情况下注册使用了我们的产品与/或服务，我们会及时与监护人协商，并设法尽快删除相关个人信息，儿童监护人也可立即终止儿童使用我们的服务并及时通知我们，以便我们采取相应的措施。儿童或其监护人对儿童个人信息处理存在疑问时，请通过本政策中的联系方式联系我们。
    </p>
    <p class="strong">温馨提示：</p>
    <p>
      1、请知悉，您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品和/或服务，您应正确引导并予以监护。
    </p>
    <p>
      2、为了验证您与儿童的监护关系的真实性以及确保监护人身份的真实性，我们可能还会需要收集您作为监护人的联系方式（手机号码和/或电子邮箱）以及其他必要的、合理的、且有助于我们判断监护关系真实性及监护人身份真实性的信息。
    </p>
    <h2>八、 本政策如何更新</h2>
    <p>发生下列重大变化情形时，我们可能会适时对本政策进行更新：</p>
    <p>
      （一） 我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；
    </p>
    <p>（二） 收集、存储、使用个人信息的范围、目的、规则发生变化；</p>
    <p>（三） 对外提供个人信息的对象、范围、目的发生变化；</p>
    <p>（四） 您访问和管理个人信息的方式发生变化；</p>
    <p>（五） 数据安全能力、信息安全风险发生变化；</p>
    <p>
      （六）
      用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；
    </p>
    <p>（七） 其他可能对您的个人信息权益产生重大影响的变化。</p>
    <p>
      如本政策发生更新，我们将以手机软件弹窗通知的方式来通知您。如您在本政策更新生效后继续使用我们的服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。
    </p>
    <p>
      您可以通过如下路径查看本政策：有看投手机软件-首页左上角个人中心-隐私管理-隐私政策。我们鼓励您在每次使用我们的产品或服务时都查阅我们的隐私政策。
    </p>
    <h2>九、 管辖与法律适用</h2>
    <p>
      （一）
      本政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。
    </p>
    <p>
      （二）
      本政策签订地为中华人民共和国上海市徐汇区。当您因为本政策的实施与我们产生任何纠纷时，首先应协商友好解决；若不能协商解决，您和我们均有权向我们住所地（上海市静安区）有管辖权的法院提起诉讼。
    </p>
    <p>
      （三）
      本政策所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本政策涵义解释的依据。
    </p>
    <p>
      （四）
      本政策条款无论因何种原因部分无效或不可执行，其余条款仍有效，对您和我们具有约束力。
    </p>
    <h2>十、 如何联系我们</h2>
    <p class="strong">(一)沟通渠道</p>
    <p>
      我们设置了个人信息保护工作机制和个人信息保护负责人，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，或您在使用有看投服务时，就您的个人信息的收集、使用、提供、访问、更正、删除、撤销与注销事宜有任何意见或建议，或您在使用有看投服务时遇到任何问题，您都可以通过以下联系方式与我们的个人信息保护负责人进行联络：
    </p>
    <p>电话：4006021010或</p>
    <p>联系邮箱：yicai@emoney.cn</p>
    <p>
      我们将在必要的身份验证通过后进行处理，在15日内对您的咨询、投诉或举报做出答复。
    </p>
    <p class="strong">(二)特别提示</p>
    <p>
      1、我们提醒您，如您反馈的问题涉及您的个人信息，尤其是您的个人敏感信息，请您不要直接在邮件或电话中进行透露，我们将会在确保您个人信息安全的情况下与您进一步沟通。
    </p>
    <p>
      2、部分情况下，为保障您个人信息安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您的身份后的合理期限内答复您的相关请求。如您对我们的答复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以相关监管部门进行投诉或举报。
    </p>
    <div id="btnCancel" class="btn-cancel" @click="showCancelAgreeDialog()">
      撤回同意并退出软件
    </div>
  </div>
</template>
<style>
html,
body {
  background-color: #ffffff;
  word-break: break-all;
}

table {
  margin: 20px 0;
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
}

table,
table tr th,
table tr td {
  border: 1px solid #000;
}

td {
  padding: 0 10px;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 10px 30px;
  max-width: 640px;
  margin: 0 auto;
  font-size: 30px;
}

h2 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}

p {
  text-indent: 2em;
}

.strong {
  font-weight: bold;
}

.btn-cancel {
  margin: 45px 22px 30px;
  border: 1px solid #dddddd;
  border-radius: 5px;
  line-height: 54px;
  text-align: center;
  font-size: 30px;
  color: #8c8c8c;
  display: none;
}

.black .btn-cancel {
  border-color: #1e262a;
  color: #828282;
}
</style>
<script>
import {getClientInfo, Log} from "@em/ym";

export default {
  name: 'PrivacyIndex',
  mounted() {
    getClientInfo(function (res) {
      if (res && res.isAgreeUse) {
        document.getElementById('btnCancel').style.display = 'block'
      }
    })

    Log.pageView({
      pageId: "Html:PrivacyIndex"
    })
  },
  methods: {
    toSdklist() {
      Log.click({
        eventId: 'ToSdklist',
      })

      this.$router.push({
        path: '/privacy/sdklist',
      })
    },
    toPersonal() {
      Log.click({
        eventId: 'ToPersonal',
      })

      this.$router.push({
        path: '/privacy/personallist',
      })
    },
    showCancelAgreeDialog() {
      Log.click({
        eventId: 'CancelAgreeDialog',
      })
      window.goods.showCancelAgreeDialog()
    }
  }
}
</script>
